import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Image from 'react-bootstrap/Image';

import Start from './Start';
import AdventureGrid from './AdventureGrid';
import CompanyView from './CompanyView';
import UserView from './UserView';
import AdminUserView from './AdminUserView';
import AdminAdventureGrid from './AdminAdventureGrid';
import ChangePasswordModal from './ChangePasswordModal';
import ChangeUserInfoModal from './ChangeUserInfoModal';
import TextAlert from './TextAlert';

import './Main.css';

class Main extends React.Component {
    constructor(props) {
	super(props);
	
	this.state = {
	    showMenu: false,
	    showChangePassword: false,
	    showChangeUserInfo: false,
	    showAlert: false,
	    alertStatus: "",
	    alertText: ""
	};

	this.handleSuccess = this.handleSuccess.bind(this);
	this.handleError = this.handleError.bind(this);
    }

    handleSuccess() {
	this.setState({
	    showMenu: false,
	    showChangePassword: false,
	    showChangeUserInfo: false,
	    showAlert: true,
	    alertStatus: "success",
	    alertText: "Uppdatering lyckades"
	});
    }
    
    handleError() {
	this.setState({
	    showMenu: false,
	    showChangePassword: false,
	    showChangeUserInfo: false,
	    showAlert: true,
	    alertStatus: "danger",
	    alertText: "Uppdatering misslyckades"
	});
    }
    
    render() {
	var isAdmin = (this.props.level == 1);

	return (
	    <>
		<Container>
		    <Row>
			<Col sm={0}>
			    <div className="onlyshowmobile">
				<Button variant="alumni" className="menubutton" size="sm" onClick={() => this.setState({showMenu: true})}><Image src="menu.png" /></Button>
			    </div>
			</Col>
		    </Row>
		</Container>

		<Tab.Container defaultActiveKey="start">
		    <Offcanvas className="menubackground" show={this.state.showMenu} onHide={() => this.setState({showMenu: false})} responsive="sm" placement="top">
			<Offcanvas.Header closeButton>
			    <Offcanvas.Title className="menutitle">&Auml;K Alumni</Offcanvas.Title>
			</Offcanvas.Header>
			<Offcanvas.Body>
			    <Nav variant="pills" className="flex-column" onSelect={() => this.setState({showMenu: false})}>
				<Row>
				    <Col>
					<Nav.Item>
					    <Nav.Link eventKey="start">V&auml;lkommen</Nav.Link>
					</Nav.Item>
				    </Col>
				    <Col>
					<Nav.Item>
					    <Nav.Link eventKey="participantadventure" >Deltagar&auml;ventyr</Nav.Link>
					</Nav.Item>
				    </Col>
				    <Col>
					<Nav.Item>
					    <Nav.Link eventKey="fridayadventure">Fredags&auml;ventyr</Nav.Link>
					</Nav.Item>
				    </Col>
				    <Col>
					<Nav.Item>
					    <Nav.Link eventKey="resources">Resursbank</Nav.Link>
					</Nav.Item>
				    </Col>
				    <Col>
					<Nav.Item>
					    <Nav.Link eventKey="alumni">Alumni</Nav.Link>
					</Nav.Item>
				    </Col>
				    <Col>
					<NavDropdown title="Konto">
					    <NavDropdown.Item onClick={() => this.setState({showChangeUserInfo: true})}>&Auml;ndra uppgifter</NavDropdown.Item>
					    <NavDropdown.Item onClick={() => this.setState({showChangePassword: true})}>&Auml;ndra l&ouml;senord</NavDropdown.Item>
					    <NavDropdown.Item onClick={() => this.props.onLoggedOut()}>Logga ut</NavDropdown.Item>
					</NavDropdown>
				    </Col>
				    {isAdmin &&
				     <Col>
					 <NavDropdown title="Admin">
					     <NavDropdown.Item eventKey="adminparticipantadventure">Deltagar&auml;ventyr</NavDropdown.Item>
					     <NavDropdown.Item eventKey="adminfridayadventure">Fredags&auml;ventyr</NavDropdown.Item>
					     <NavDropdown.Item>Resursbank</NavDropdown.Item>
					     <NavDropdown.Item eventKey="adminalumni">Anv&auml;ndare</NavDropdown.Item>
					 </NavDropdown>
				     </Col>
				    }

				</Row>
			    </Nav>
			</Offcanvas.Body>
		    </Offcanvas>

		    <TextAlert variant={this.state.alertStatus}
			       text={this.state.alertText}
			       show={this.state.showAlert}
			       onHide={() => this.setState({showAlert: false})}
		    />

		    <Tab.Content>
			<Tab.Pane eventKey="start">
			    <Start />
	     		</Tab.Pane>
	     		<Tab.Pane eventKey="participantadventure">
			    <AdventureGrid type="1" token={this.props.token} onAuthError={this.props.onLoggedOut} />
	     		</Tab.Pane>
	     		<Tab.Pane eventKey="fridayadventure">
		 	    <AdventureGrid type="0" token={this.props.token} onAuthError={this.props.onLoggedOut} />
	     		</Tab.Pane>
	     		<Tab.Pane eventKey="resources">
			    <CompanyView token={this.props.token} onAuthError={this.props.onLoggedOut} />
	     		</Tab.Pane>
	     		<Tab.Pane eventKey="alumni">
			    <UserView token={this.props.token} onAuthError={this.props.onLoggedOut} />
	     		</Tab.Pane>
	     		<Tab.Pane eventKey="adminparticipantadventure">
			    <AdminAdventureGrid
				type="1"
				token={this.props.token}
				onSuccess={this.handleSuccess}
				onError={this.handleError}
				onAuthError={this.props.onLoggedOut} />
	     		</Tab.Pane>
	     		<Tab.Pane eventKey="adminfridayadventure">
			    <AdminAdventureGrid
				type="0"
				token={this.props.token}
				onSuccess={this.handleSuccess}
				onError={this.handleError}
				onAuthError={this.props.onLoggedOut} />
	     		</Tab.Pane>
	     		<Tab.Pane eventKey="adminalumni">
			    <AdminUserView
				token={this.props.token}
				onSuccess={this.handleSuccess}
				onError={this.handleError}
				onAuthError={this.props.onLoggedOut} />
	     		</Tab.Pane>
		    </Tab.Content>
		</Tab.Container>

		<ChangeUserInfoModal show={this.state.showChangeUserInfo}
				     username={this.props.username}
				     userid={this.props.userid}
				     token={this.props.token}
				     onHide={() => this.setState({showChangeUserInfo: false})}
				     onSuccess={this.handleSuccess}
				     onError={this.handleError}
				     onAuthError={this.props.onLoggedOut}
		/>

		<ChangePasswordModal show={this.state.showChangePassword}
				     username={this.props.username}
				     userid={this.props.userid}
				     token={this.props.token}
				     onHide={() => this.setState({showChangePassword: false})}
				     onSuccess={this.handleSuccess}
				     onError={this.handleError}
				     onAuthError={this.props.onLoggedOut}
		/>
	    </>
	);
    }
}

export default Main;
